// extracted by mini-css-extract-plugin
export default {"view":"unsupported_view__53n5M"};